const PRIVACY_URL = "https://www.wearetheweave.co.uk/privacy-policy";
const TERMS_URL = "https://www.wearetheweave.co.uk/terms-of-service";

export default function Footer() {
  return (
    <footer
      className="border-t border-slate-100 mt-12"
      data-testid="site-footer"
    >
      <div className="max-w-3xl mx-auto px-6 py-10 flex flex-col gap-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span
              className="weave-dot"
              style={{ background: "#4aa0a4" }}
              aria-hidden="true"
            />
            <span className="text-sm text-slate-500">
              Stay AWAKE · A thinking tool by{" "}
              <a
                href="https://www.wearetheweave.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-700 font-medium hover:text-[#3c8386] transition-colors"
                data-testid="footer-weave-link"
              >
                The Weave
              </a>
            </span>
          </div>
          <div className="flex items-center gap-5 text-xs text-slate-400">
            <span>Attention</span>
            <span aria-hidden="true">·</span>
            <span>Witness</span>
            <span aria-hidden="true">·</span>
            <span>Align</span>
            <span aria-hidden="true">·</span>
            <span>Kata</span>
            <span aria-hidden="true">·</span>
            <span>Evolve</span>
          </div>
        </div>
        <div className="flex items-center gap-4 text-xs text-slate-400 pt-2 border-t border-slate-50">
          <a
            href={PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#3c8386] transition-colors"
            data-testid="footer-privacy-link"
          >
            Privacy policy
          </a>
          <span aria-hidden="true">·</span>
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#3c8386] transition-colors"
            data-testid="footer-terms-link"
          >
            Terms of service
          </a>
        </div>
      </div>
    </footer>
  );
}
